// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getWeeklyProductivityImprovementApi(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/weekly/productivity_improvement`);
}
